module.exports = __webpack_public_path__ + "static/img/1022_big.79b9118.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1022_big.png
// module id = sw70
// module chunks = 1